import { i18n } from '../utils.js';

;( function( $, window, undefined ) {

  'use strict';

  // global
  var Modernizr = window.Modernizr, $body = $( 'body' );

  $.MenuMultiLevel = function( options, element ) {
    this.$el = $( element );
    this._init( options );
  };

  // the options
  $.MenuMultiLevel.defaults = {
    // classes for the animation effects
    animationClasses : { classin : 'animate-in', classout : 'animate-out' },
    subMenuSelector: '.menu-sublist',
    menuSelector: 'ul.mml-menu',
    triggerSelector: '.mml-trigger',
    // callback: click a link that has a sub menu
    // el is the link element (li); name is the level name
    onLevelClick : function( el, name ) { return false; },
    // callback: click a link that does not have a sub menu
    // el is the link element (li); ev is the event obj
    onLinkClick : function( el, ev ) { return false; }
  };

  $.MenuMultiLevel.prototype = {
    _init : function( options ) {
      // options
      this.options = $.extend( true, {}, $.MenuMultiLevel.defaults, options );
      // cache some elements and initialize some variables
      this._config();

      var animEndEventNames = {
          'WebkitAnimation' : 'webkitAnimationEnd',
          'OAnimation' : 'oAnimationEnd',
          'msAnimation' : 'MSAnimationEnd',
          'animation' : 'animationend'
        },
        transEndEventNames = {
          'WebkitTransition' : 'webkitTransitionEnd',
          'MozTransition' : 'transitionend',
          'OTransition' : 'oTransitionEnd',
          'msTransition' : 'MSTransitionEnd',
          'transition' : 'transitionend'
        };
      // animation end event name
      this.animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ] + '.menumultilevel';
      // transition end event name
      this.transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ] + '.menumultilevel',
      // support for css animations and css transitions
      this.supportAnimations = Modernizr.cssanimations,
      this.supportTransitions = Modernizr.csstransitions;

      this._initEvents();

    },
    _config : function() {
      // this.event = (navigator.userAgent.match(/iPad/i)) ? 'touchstart.menumultilevel' : 'click.menumultilevel';
      this.open = false;
      this.$trigger = this.$el.children( this.options.triggerSelector );
      this.$menu = this.$el.children( this.options.menuSelector );
      this.$menuitems = this.$menu.find( 'li:not(.mml-back)');
      this.$menuitems.addClass('mml-item');
      this.$el.find( this.options.subMenuSelector )
        .addClass( 'mml-submenu' )
        .prepend( `
          <li class="menu-item mml-back mml-item">
            <a href="#" class="menu-link">${i18n('form.back')}</a>
          </li>`
        );
      this.$back = this.$menu.find( 'li.mml-back' );
    },
    _initEvents : function() {
      var self = this;

      this.$trigger.on( 'click.menumultilevel', function(e) {
        if( self.open ) {
          self._closeMenu();
        }
        else {
          self._openMenu();
        }
        return false;

      } );

      this.$menuitems.on( 'click.menumultilevel', function( event ) {
        event.stopPropagation();

        var $item = $(this),
          $submenu = $item.children( 'ul.mml-submenu' );

        if( $submenu.length > 0 ) {

          var $flyin = $submenu.clone().css( 'opacity', 0 ).insertAfter( self.$menu ),
            onAnimationEndFn = function() {
              self.$menu.off( self.animEndEventName ).removeClass( self.options.animationClasses.classout ).addClass( 'mml-subview' );
              $item.addClass( 'mml-subviewopen' ).parents( '.mml-subviewopen:first' ).removeClass( 'mml-subviewopen' ).addClass( 'mml-subview' );
              $flyin.remove();
            };

          setTimeout( function() {
            $flyin.addClass( self.options.animationClasses.classin );
            self.$menu.addClass( self.options.animationClasses.classout );
            if( self.supportAnimations ) {
              self.$menu.on( self.animEndEventName, onAnimationEndFn );
            }
            else {
              onAnimationEndFn.call();
            }

            self.options.onLevelClick( $item, $item.children( 'a:first' ).text() );
          } );

          return false;

        }
        else {
          self.options.onLinkClick( $item, event );
        }

      } );

      this.$back.on( 'click.menumultilevel', function( event ) {

        var $this = $( this ),
          $submenu = $this.parents( 'ul.mml-submenu:first' ),
          $item = $submenu.parent(),

          $flyin = $submenu.clone().insertAfter( self.$menu );

        var onAnimationEndFn = function() {
          self.$menu.off( self.animEndEventName ).removeClass( self.options.animationClasses.classin );
          $flyin.remove();
        };

        setTimeout( function() {
          $flyin.addClass( self.options.animationClasses.classout );
          self.$menu.addClass( self.options.animationClasses.classin );
          if( self.supportAnimations ) {
            self.$menu.on( self.animEndEventName, onAnimationEndFn );
          }
          else {
            onAnimationEndFn.call();
          }

          $item.removeClass( 'mml-subviewopen' );

          var $subview = $this.parents( '.mml-subview:first' );
          if( $subview.is( 'li' ) ) {
            $subview.addClass( 'mml-subviewopen' );
          }
          $subview.removeClass( 'mml-subview' );
        } );

        return false;

      } );
    },
    closeMenu : function() {
      if( this.open ) {
        this._closeMenu();
      }
    },
    _closeMenu : function() {
      var self = this,
        onTransitionEndFn = function() {
          self.$menu.off( self.transEndEventName );
          self._resetMenu();
        };

      this.$menu.removeClass( 'mml-open' );
      this.$menu.addClass( 'mml-toggle' );
      this.$trigger.removeClass( 'mml-active' );

      if( this.supportTransitions ) {
        this.$menu.on( this.transEndEventName, onTransitionEndFn );
      }
      else {
        onTransitionEndFn.call();
      }

      $body.css('cursor', 'auto');
      this.open = false;
    },
    openMenu : function() {
      if( !this.open ) {
        this._openMenu();
      }
    },
    _openMenu : function() {
      var self = this;
      // clicking somewhere else makes the menu close
      $body.off( 'click' )
           .css('cursor', 'pointer')
           .on( 'click.menumultilevel', function() {
              self._closeMenu() ;
            } );
      this.$menu.addClass( 'mml-open mml-toggle' ).on( this.transEndEventName, function() {
        $( this ).removeClass( 'mml-toggle' );
      } );
      this.$trigger.addClass( 'mml-active' );
      this.open = true;
    },
    // resets the menu to its original state (first level of options)
    _resetMenu : function() {
      this.$menu.removeClass( 'mml-subview' );
      this.$menuitems.removeClass( 'mml-subview mml-subviewopen' );
    }
  };

  var logError = function( message ) {
    if ( window.console ) {
      window.console.error( message );
    }
  };

  $.fn.menuMultiLevel = function( options ) {
    if ( typeof options === 'string' ) {
      var args = Array.prototype.slice.call( arguments, 1 );
      this.each(function() {
        var instance = $.data( this, 'menumultilevel' );
        if ( !instance ) {
          logError( "cannot call methods on menumultilevel prior to initialization; " +
          "attempted to call method '" + options + "'" );
          return;
        }
        if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
          logError( "no such method '" + options + "' for menumultilevel instance" );
          return;
        }
        instance[ options ].apply( instance, args );
      });
    }
    else {
      this.each(function() {
        var instance = $.data( this, 'menumultilevel' );
        if ( instance ) {
          instance._init();
        }
        else {
          instance = $.data( this, 'menumultilevel', new $.MenuMultiLevel( options, this ) );
        }
      });
    }
    return this;
  };

} )( jQuery, window );



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/menu-multilevel.js